function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M15.3033 4.6967C18.2323 7.62563 18.2323 12.3744 15.3033 15.3033C12.3744 18.2322 7.62568 18.2322 4.69676 15.3033C1.76783 12.3744 1.76783 7.62562 4.69676 4.6967C7.62569 1.76777 12.3744 1.76777 15.3033 4.6967",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = React.createElement("path", {
  d: "M13.7484 7.88666C11.6784 8.57416 8.32169 8.57416 6.25085 7.88666",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = React.createElement("path", {
  d: "M9.99998 8.45832C9.99998 10.9583 9.66705 12.5538 8.33331 14.2917",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = React.createElement("path", {
  d: "M10 8.45832C10 10.9583 10.3329 12.5538 11.6667 14.2917",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = React.createElement("path", {
  d: "M10.2799 5.63677C10.4345 5.79135 10.4345 6.04198 10.2799 6.19656C10.1254 6.35115 9.87473 6.35115 9.72014 6.19656C9.56556 6.04198 9.56556 5.79135 9.72014 5.63677C9.87473 5.48219 10.1254 5.48219 10.2799 5.63677",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgA11Y = function SvgA11Y(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgA11Y, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/a11y.4e552ecb.svg";
export { ForwardRef as ReactComponent };